import Providers from '~/components/layouts/providers'

export default function LayoutBlank({ children }: { children: React.ReactNode }) {
  return <Providers>{children}</Providers>
}
